import { Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";

const UserHeaderClient = ({ clientData }) => {
  return (
    <>
      <Flex style={{ padding: "5px 10px" }} justifyContent={"end"}>        
        {/* <Text
          fontStyle="italic"
          px={2}
          fontSize="var(--sylvr-h4-fs)"
          fontWeight="var(--sylvr-h5-fw)"
          color="var(--sylvr-text-color)"
        >
          SME profile 50% complete. Make it 100 to unlock profile
          discoverability
        </Text> */}
      </Flex>
    </>
  );
};

export default UserHeaderClient;
